import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { fas } from "@fortawesome/free-solid-svg-icons";

const style = { fontSize: 30 };
const color = "#f6a400";

// const icons_list = [
//   "fa_image",
//   "fa_bell",
//   "fa_phone",
//   "fa_signal",
//   "fa_universal_access",
//   "fa_video_camera",
//   "fa_plug",
// ];

const camelToSnake = (str) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

const icons_list = Array.from(
  new Set(
    Object.keys(fas).map((icon) => ({
      name: camelToSnake(icon),
      real_name: icon,
    }))
  )
);

export const getIssueKindIcon = (name) => {
  const iconName = toFaIconName(name);
  const icon = fas[iconName];

  if (!icon) return null;

  return <FontAwesomeIcon icon={icon} style={style} color={color} />;
};

const toFaIconName = (name) =>
  name.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

const issue_kind_icons = icons_list.map(({ name, real_name }) => ({
  name,
  real_name,
  icon: () => getIssueKindIcon(name),
}));

export default issue_kind_icons;
